<template>
    <div>
        <div>
            <div class="top-text">
                <h5>Assigned Request</h5>
                <h6>Manage all assigned properties, FMs, and maintenance tasks sent to you for action</h6>
            </div>
            <hr>
            <div class="request-holder">
                <div class="top-flex">
                    <div class="request-btns">
                        <button class="btn" :class="[requestOption == 0 ? 'activeBtnRequest' : '']" @click="requestOption = 0">Property Management</button>
                        <button class="btn" @click="requestOption = 1" :class="[requestOption == 1 ? 'activeBtnRequest' : '']">Inspection</button>
                        <button class="btn" :class="[requestOption == 2 ? 'activeBtnRequest' : '']" @click="requestOption = 2">Facility Management</button>
                        <button class="btn" :class="[requestOption == 3 ? 'activeBtnRequest' : '']" @click="requestOption = 3">Maintainance</button>
                        <button class="btn" :class="[requestOption == 4 ? 'activeBtnRequest' : '']" @click="requestOption = 4">FM/IO</button>
    
        
                    </div>
                    <!-- <div class="filter-side">
                        <span><i class="fa fa-filter"></i></span>
                        <select name="" id="" class="form-control">
                            <option value="">Pending</option>
                            <option value="">Accepted</option>
                            <option value="">Rejected</option>
                            <option value="">Expired</option>
                        </select>
                    </div> -->
                </div>
                <hr>


                <div class="table-responsive tableList" v-if="requestOption == 0">
                    <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                    <table class="table" v-if="!loading && propertyManagement.length != 0">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Property address</th>
                                <th scope="col">Date Assigned</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in propertyManagement"
                                :key="index"
                                :value="item.id">
                                <td>{{index + 1}}</td>
                                <td class="text-wrap" style="max-width: 339px; min-width: 200px;">{{item.property.address}}</td>
                                <td>{{item.date | moment}}</td>
                                <td style=" text-transform: capitalize;"><span :class="[item.status == 'accepted' ? 'acceptedStaus' : '', item.status == 'rejected' ? 'rejectedStatus' : '', item.status == 'pending' ? 'pendingStatus' : '']">{{item.status}}</span></td>
                                <td style="cursor: pointer;"  @click="moveToPropertyDetails(item.property.batch)">View details</td>
                                <td><button :disabled="item.accepted == 'NO' || item.re_assigned == 'YES'" class="reasignBtnTable btn" @click="isDrawerOpen = true; propManagementId = item.id; maxPercentage = item.property.maxpercentage">Reassign</button></td>
                                <!-- <td>
                                    <img class="dropdown-toggle" style="cursor: pointer;" src="../assets/icons/menu-icon.svg" alt="menu" data-toggle="dropdown" aria-expanded="false">
                                    <div class="dropdown-menu">
                                    <a @click="viewLandlordDetails(item.id)" class="dropdown-item">View details</a>
                                    <a @click="addProperty(item.id)" class="dropdown-item">Add property (unit)</a>
                                    <a class="dropdown-item">Generate report</a>
                                    <a class="dropdown-item">Delete</a>
                                    </div>
                                </td> -->
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="propertyManagement.length == 0 && !loading">
                        <EmptyState :emptyData="emptyDataObject" />
                    </div>
                </div>
                <div class="table-responsive tableList" v-if="requestOption == 1">
                    <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                    <table class="table" v-if="!loading && inspectionList.length != 0">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Property address</th>
                                <th scope="col">Inspection fee</th>
                                <th scope="col">Inspection fee status</th>
                                <th scope="col">Date Assigned</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in inspectionList"
                                :key="index"
                                :value="item.id">
                                <td>{{index + 1}}</td>
                                <td class="text-wrap" style="max-width: 339px; min-width: 200px;">{{item.property.address}}</td>
                                <td>₦{{ Number(item.inspection_fee).toLocaleString() }}</td>
                                <td>{{ item.inspection_fee_status }}</td>
                                <td>{{item.date | moment}}</td>
                                <td style=" text-transform: capitalize;"><span :class="[item.status == 'accepted' ? 'acceptedStaus' : '', item.status == 'rejected' ? 'rejectedStatus' : '']">{{item.status}}</span></td>
                                <td style="cursor: pointer;" @click="moveToPropertyDetails(item.property.batch)">View details</td>
                                <!-- <td>
                                    <img class="dropdown-toggle" style="cursor: pointer;" src="../assets/icons/menu-icon.svg" alt="menu" data-toggle="dropdown" aria-expanded="false">
                                    <div class="dropdown-menu">
                                    <a @click="viewLandlordDetails(item.id)" class="dropdown-item">View details</a>
                                    <a @click="addProperty(item.id)" class="dropdown-item">Add property (unit)</a>
                                    <a class="dropdown-item">Generate report</a>
                                    <a class="dropdown-item">Delete</a>
                                    </div>
                                </td> -->
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="inspectionList.length == 0 && !loading">
                        <EmptyState :emptyData="emptyDataObject" />
                    </div>
                </div>

                <div class="table-responsive tableList" v-if="requestOption == 2">
                    <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                    <table class="table" v-if="!loading && managementList.length != 0">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Property address</th>
                                <th scope="col">Date Assigned</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in managementList"
                                :key="index"
                                :value="item.id">
                                <td>{{index + 1}}</td>
                                <td class="text-wrap" style="max-width: 339px; min-width: 200px;">{{item.property.address}}</td>
                                <td>{{item.date | moment}}</td>
                                <td style=" text-transform: capitalize;"><span :class="[item.status == 'accepted' ? 'acceptedStaus' : '', item.status == 'rejected' ? 'rejectedStatus' : '']">{{item.status}}</span></td>
                                <td style="cursor: pointer;"  @click="moveToPropertyDetails(item.property.batch)">View details</td>
                                <!-- <td>
                                    <img class="dropdown-toggle" style="cursor: pointer;" src="../assets/icons/menu-icon.svg" alt="menu" data-toggle="dropdown" aria-expanded="false">
                                    <div class="dropdown-menu">
                                    <a @click="viewLandlordDetails(item.id)" class="dropdown-item">View details</a>
                                    <a @click="addProperty(item.id)" class="dropdown-item">Add property (unit)</a>
                                    <a class="dropdown-item">Generate report</a>
                                    <a class="dropdown-item">Delete</a>
                                    </div>
                                </td> -->
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="managementList.length == 0 && !loading">
                        <EmptyState :emptyData="emptyDataObject" />
                    </div>
                </div>

                <div class="table-responsive tableList" v-if="requestOption == 3">
                    <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                    <table class="table" v-if="!loading && maintainanceList.length != 0">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Property address</th>
                                <th scope="col">Date Assigned</th>
                                <th scope="col">Issue</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in maintainanceList"
                                :key="index"
                                :value="item.id">
                                <td>{{index + 1}}</td>
                                <td class="text-wrap" style="max-width: 339px; min-width: 200px;" v-if="item.property">{{item.property.address}}</td>
                                <td>{{item.created_at | moment}}</td>
                                <td>{{item.issue}}</td>
                                <td style=" text-transform: capitalize;"><span :class="[item.status == 'accepted' ? 'acceptedStaus' : '', item.status == 'rejected' ? 'rejectedStatus' : '']">{{item.status}}</span></td>
                                <td style="cursor: pointer;" @click="moveToPropertyDetails(item.property.batch)">View details</td>
                                <!-- <td>
                                    <img class="dropdown-toggle" style="cursor: pointer;" src="../assets/icons/menu-icon.svg" alt="menu" data-toggle="dropdown" aria-expanded="false">
                                    <div class="dropdown-menu">
                                    <a @click="viewLandlordDetails(item.id)" class="dropdown-item">View details</a>
                                    <a @click="addProperty(item.id)" class="dropdown-item">Add property (unit)</a>
                                    <a class="dropdown-item">Generate report</a>
                                    <a class="dropdown-item">Delete</a>
                                    </div>
                                </td> -->
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="maintainanceList.length == 0 && !loading">
                        <EmptyState :emptyData="emptyDataObject" />
                    </div>
                </div>

                <div class="table-responsive tableList" v-if="requestOption == 4">
                    <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                    <table class="table" v-if="!loading && FmIoList.length != 0">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">FM/IO Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Code</th>
                                <th scope="col">Date Assigned</th>
                                <!-- <th scope="col">Status</th> -->
                                <!-- <th scope="col">Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in FmIoList"
                                :key="index"
                                :value="item.id">
                                <td>{{index + 1}}</td>
                                <td>{{item.user.firstname}} {{item.user.lastname}}</td>
                                <td>{{item.user.email}}</td>
                                <td>{{item.user.phone}}</td>
                                <td>{{item.user.usercode}}</td>
                                <td>{{item.created_at | moment}}</td>
                                <!-- <td style=" text-transform: capitalize;">{{item.status}}</td> -->
                                <!-- <td>View details</td> -->
                                <!-- <td>
                                    <img class="dropdown-toggle" style="cursor: pointer;" src="../assets/icons/menu-icon.svg" alt="menu" data-toggle="dropdown" aria-expanded="false">
                                    <div class="dropdown-menu">
                                    <a @click="viewLandlordDetails(item.id)" class="dropdown-item">View details</a>
                                    <a @click="addProperty(item.id)" class="dropdown-item">Add property (unit)</a>
                                    <a class="dropdown-item">Generate report</a>
                                    <a class="dropdown-item">Delete</a>
                                    </div>
                                </td> -->
                            </tr>
                        
                        </tbody>
                    </table>
                    <div v-if="FmIoList.length == 0 && !loading">
                        <EmptyState :emptyData="emptyDataObject" />
                    </div>
                </div>

                <!-- Overlay -->
                <div 
                    v-if="isDrawerOpen" 
                    class="overlay"
                    @click="isDrawerOpen = false"
                ></div>
                <!-- Side Drawer -->
                <transition name="slide">
                    <div v-if="isDrawerOpen" class="drawer">
                        <div class="top-drawer">
                            <h2>Reassign FM/IO</h2>
                            <button style="padding: 2px 5px;" class="close-btn" @click="isDrawerOpen = false">×</button>
                        </div>
                        <hr>
                        <div class="mt-5">
                            <div class="form-group">
                                <label for="fm">Select FM</label>
                                <select class="form-control dynamic-input" name="fm" id="fm" v-model="selectedFM">
                                    <option value="" disabled selected>Select FM</option>
                                    <option
                                        v-for="item in sortedFms"
                                        :key="item.id"
                                        :value="item.id"
                                        
                                        >{{ item.user.firstname }} {{ item.user.lastname }}</option
                                    >
                                </select>
                            </div>
                            <div class="form-group mt-4">
                                <label for="paymentType">Payment type</label>
                                <div class="payment-type">
                                    <button class="btn activeBtnAssign">Percentage</button>
                                    <button class="btn">Cash</button>
                                </div>
                            </div>

                            <!-- <div class="form-group mt-4">
                                <label for="percentage">Percentage</label>
                                <select class="form-control dynamic-input" name="percentage" id="percentage" v-model="percentage">
                                    <option value="" disabled selected>Select</option>
                                    <option
                                        v-for="item in percentageNumbers"
                                        :key="item"
                                        :value="item"
                                        
                                        >{{ item}}%</option
                                    >
                                </select>
                            </div> -->
                            <div class="mt-4">
                               
                                <div class="form-group">
                                    <label for="percentage2">Percentage(%)</label>
                                    <input v-model="percentage" @input="enforceMax" type="number" :max="maxPercentage" :min="minPercentage" class="form-control" id="percentage2" placeholder="Percentage">
                                </div>
                                 
                            </div>
                            <div class="mt-4">
                                <label for="duration">Duration</label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="startdate" style="font-family: 13px;">Start date</label>
                                            <input v-model="startdate" type="date" :min="minDate" class="form-control" id="startdate" placeholder="Start date">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="enddate" style="font-family: 13px;">End date</label>
                                            <input :disabled="startdate == ''" v-model="enddate" type="date" :min="minDate" class="form-control" id="enddate" placeholder="End date">
                                        </div>
                                    </div>
                            
                                </div>
                            </div>
                            <div class="mt-4">
                                <div class="form-group">
                                    <label for="note">Note</label>
                                    <textarea v-model="notes" class="form-control" name="note" id="note"></textarea>
                                </div>
                            </div>

                            <div class="form-group mt-5">
                                <div class="payment-type">
                                    <button :disabled="loadingReassign" class="btn" @click="isDrawerOpen = false">Cancel</button>
                                    <button class="btn activeBtnAssign" :disabled="loadingReassign" @click="reassignRequest()">Reassign
                                        <span v-if="loadingReassign"><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>


<script>
import partners from '../services/partners';
import EmptyState from "../components/EmptyState.vue";
import Loader from '../components/Loader';
import moment from 'moment';
import properties from '../services/properties';

export default {
    name: "AssinedRequests",
    components: {
        Loader,
        EmptyState
    },
    // props: {
    //     emptyData: {
    //         type: Object,
    //         required: true,
    //     }
    // },
    data() {
        return {
            loading: false,
            isDrawerOpen: false,
            loadingReassign: false,
            requestOption: 0,
            userID: "",
            inspectionList: [],
            maintainanceList: [],
            managementList: [],
            FmIoList: [],
            propertyManagement: [],
            percentageNumbers: [],
            sortedFms: [],
            selectedFM: "",
            percentage: "",
            startdate: "",
            propManagementId: "",
            maxPercentage: null,
            minPercentage: 0,
            notes: "",
            enddate: "",
            emptyDataObject: {
                header: 'No record found',
                option: 'Record will be displayed when updated or avaialable'
            },
            minDate: new Date().toISOString().split('T')[0]  // today
            // today: new Date().toISOString().split("T")[0] , // 'YYYY-MM-DD' format

        }
    },
    created() {
        this.batch = this.$route.params.id;
    },
    mounted() {
        let user = this.$store.getters.getUser;
        this.userData = this.$store.getters.getUser;
        this.userID = user.id;
        this.percentageNumbers = Array.from({ length: 9 }, (_, i) => i + 2);
        // console.log(this.percentageNumbers); // [2, 3, 4, 5, 6, 7, 8, 9, 10]

        this.FetchAllRequests();
    },
    methods: {
        moveToPropertyDetails(batch) {
            // console.log("Unit details")
            this.$router.push({path: `/user/partner/property-details/${batch}`});
        },
        enforceMax() {
            if (this.percentage > this.maxPercentage) {
                this.percentage = this.maxPercentage;
            }
        },
        async reassignRequest() {
            let payload = {
                partner_property_management_id: this.propManagementId,
                facility_manager_id: this.selectedFM,
                percentage: this.percentage,
                notes: this.notes,
                re_assigned_start_date: this.startdate,
                re_assigned_end_date: this.enddate,
            }
            if (Number(this.percentage) > Number(this.maxPercentage)) {
                return this.$toast.error(`Percentage should not be more than ${this.maxPercentage}%`);
            }
            if (this.partner_property_management_id == '' || this.selectedFM == "" || this.percentage == "" || this.startdate == "" || this.enddate == "") {
                return this.$toast.error("Fill all required fields");
            }
            if (this.enddate && this.startdate && new Date(this.enddate) < new Date(this.startdate)) {
                return this.$toast.error("End Date cannot be earlier than Start Date.");
            }
            this.loadingReassign = true;
            try {
                await properties.partnerReassignRequest(JSON.stringify(payload)).then(res => {
                    this.loadingReassign = false;
                    if (res.success) {
                        this.$toast.success(res.success);
                        this.isDrawerOpen = false;
                        this.FetchAllRequests();
                        this.partner_property_management_id = "";
                        this.facility_manager_id = "";
                        this.percentage = "";
                        this.notes = "";
                        this.re_assigned_start_date = "";
                        this.re_assigned_end_date = "";

                    }
                    if (res.error) {
                        this.$toast.error(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loadingReassign = false;
                });
            } finally {
                // console.log("closed");
            }
        },
        async FetchAllRequests() {
            this.loading = true;
            try {
                await partners.fetchAllRequests(this.userID).then(res => {
                    // console.log("request rresponse", res)
                    this.loading = false;
                    if (res.success) {
                        this.inspectionList = res.inspection;
                        this.maintainanceList = res.maintenance_request;
                        this.managementList = res.management;
                        this.FmIoList = res.fm_io;
                        this.propertyManagement = res.partner_property_management_request;

                        this.sortedFms = this.FmIoList.filter(item => item.type == 'FM');
                        // console.log("sorted Fm", this.sortedFms);
                    }
                    if (res.error) {
                        this.$toast.success(res.error);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    // this.requestLoader = false;
                    // this.requestLoader2 = false;
                    this.requestId = "";
                });
            } finally {
                // console.log("closed");
            }
        }
    },
    filters: {
        moment: function(date) {
        return moment(date).format('MMMM Do YYYY');
        }
        // moment: function(date) {
        //   return moment(date).format('MMMM DD YYYY, h:mm:ss a');
        // }
    },
    immediate: true
}
</script>


<style lang="scss" scoped>
.top-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.top-text {
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #2B3352;
        margin-bottom: 1%;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #555C74;

    }
}

.request-holder {
    margin-top: 40px;
}

.request-btns {
    overflow: auto;
    display: flex;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        color: #555C74;
        border-bottom: 1px solid #555C74;
        border-radius: 0;
        box-shadow: none;
        outline: 0;
        border: 0;
        padding-top: 15px;
        padding-bottom: 15px;

    }
    .btn {
        // border: 0px solid transparent;
    }

}

.activeBtnRequest {
    font-family: Lato;
    font-weight: 600;
    font-size: 16px;
    color: #0033EA !important;
    border-bottom: 1px solid #0033EA !important;
    border-radius: 0;
    box-shadow: none;
    outline: 0;
}
.filter-side {
    display: flex;
    gap: 10px;
}


// Table css starts
.tableList {
    // margin-top: 30px;
    margin-bottom: 20px;
    border: 2px solid #EAECF0;
    border-radius: 20px;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    background: #EAECF0;
}
thead th {
    white-space: nowrap;
    font-family: Lato;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    color: #667085;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #667085;
}

.reasignBtnTable {
    background: #0033EA;
    color: #ffffff;
    padding: 10px;
    font-family: Lato;
    font-weight: 400;
    font-size: 13px;
    cursor: pointer;
    border-radius: 4px;
    outline: 0;
    box-shadow: none;
}
// Table css ends

.acceptedStaus {
    font-size: 12px;
    color: #067647;
    background: #ECFDF3;
    border: 1px solid #ABEFC6;
    border-radius: 50px;
    padding: 2px 8px;
}
.rejectedStatus {
    font-size: 12px;
    color: #B42318;
    background: #FEF3F2;
    border: 1px solid #FECDCA;
    border-radius: 50px;
    padding: 2px 8px;
}

.pendingStatus {
    font-size: 12px;
    background: #f0f0f0;
    border: 1px solid #667085;
    border-radius: 50px;
    padding: 2px 8px;
}


// Side drawer starts
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.drawer {
  margin-top: 94px; 
  position: fixed;
  top: 0;
  right: 0;
  width: 350px;
  //   height: 100%;
  height: 80%;
  overflow: scroll;
  background: #fff;
  padding: 20px;
  z-index: 1000;
  box-shadow: -2px 0 8px rgba(0,0,0,0.2);
}

/* Transition for sliding */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}

.top-drawer {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    padding-bottom: 0 !important;
    h2 {
        font-family: Lato;
        font-weight: 600;
        font-size: 24px;
        line-height: 20px;
        color: #2B3352;

    }
}
label {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #555C74;
}
input, select {
    height: 50px;
    border: 1px solid #D5D7DA !important;
    outline: 0 !important;
    box-shadow: none !important;
    width: 100%;
}
textarea {
    outline: 0 !important;
    box-shadow: none !important;
}

.payment-type {
    display: flex;
    gap: 20px;
    button {
        border: 1px solid #E9EAEB;
        background: #F5F5F5;
        color: #555C7499;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        width: 100%;
        box-shadow: none;
        outline: 0;
    }
}

.activeBtnAssign {
    background: #0033EA !important;
    color: #ffffff !important;
}
// side drawer ends

@media screen and (max-width: 599px) { 
    .top-flex {
        display: block;
    }
    .filter-side {
        margin-top: 30px;
    }
}
</style>